import {useIntl} from "react-intl";
import {Field} from "formik";

interface FormFinancialInfoProps {
    errors?: any;
    values?: any;
}

export function FormFinancialInfo(props: FormFinancialInfoProps) {
    const {errors, values} = props;
    const intl = useIntl();

    return (
        <div className="row container-border-app">
            <div className="row">
                <div className="col-12 text-left">
                    <h3>Información Financiera</h3>
                </div>
            </div>
            
            <div className="row">
                {/* Activos */}
                <div className="col-md-3">
                    <div className={"label-fields-peps-mobile display-flex"}>Activos</div>
                    <div className="display-flex">
                        <Field 
                            name="Pws_Act_finan" 
                            type="number"
                            className={`${errors.Pws_Act_finan ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder="Valor de activos"
                        />
                    </div>
                </div>
                
                {/* Pasivos */}
                <div className="col-md-3">
                    <div className={"label-fields-peps-mobile display-flex"}>Pasivos</div>
                    <div className="display-flex">
                        <Field 
                            name="Pws_Pasiv_finan" 
                            type="number"
                            className={`${errors.Pws_Pasiv_finan ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder="Valor de pasivos"
                        />
                    </div>
                </div>
                
                {/* Ingresos */}
                <div className="col-md-3">
                    <div className={"label-fields-peps-mobile display-flex"}>Ingresos</div>
                    <div className="display-flex">
                        <Field 
                            name="Pws_ingres_finan" 
                            type="number"
                            className={`${errors.Pws_ingres_finan ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder="Valor de ingresos"
                        />
                    </div>
                </div>
                
                {/* Egresos */}
                <div className="col-md-3">
                    <div className={"label-fields-peps-mobile display-flex"}>Egresos</div>
                    <div className="display-flex">
                        <Field 
                            name="Pws_egres_finan" 
                            type="number"
                            className={`${errors.Pws_egres_finan ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder="Valor de egresos"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}